module.exports = __webpack_public_path__ + "assets/img/store_pda_config.11dd9bd4.png";